import { Footer } from "@layouts/Footer";
import heroImage from "@assets/images/Group-1410087705.svg";
import mailIcon from "@assets/images/mail-fill.svg";
import phoneIcon from "@assets/images/phone-fill.svg";
import buildingIcon from "@assets/images/building-2-fill.svg";
import emergencyIcon from "@assets/icons/emergencyIcon.svg";
import { HeroSection, EmergencyCTASection } from "../../components";
import { ContactPage } from "@features/general";

export function Contact() {
  return (
    <ContactPage
      hero={
        <HeroSection
          title="We're Always Here for You"
          description="Whether you need help with your bill, want to apply for a new connection, or simply have a question about your gas supply — Gaz Investment in Oil and Gas Supply L.L.C. (GAZ) is here 24 hours a day to support you."
          heroImage={heroImage}
          badgeIcon={<img src={emergencyIcon} alt="" className="w-7 h-7" />}
        />
      }
      footer={
        <>
          <EmergencyCTASection
            title="Need Immediate Assistance?"
            subtitle={
              <>
                Call our 24/7 Emergency Line: 800-GAZ (42747)
                <br />
                or report a concern via our Online Safety Form.
              </>
            }
          >
            <div className="rounded-3xl bg-white flex flex-col items-start p-6 gap-4">
              <div className="flex items-center gap-2.5">
                <img src={mailIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  help@gazglobal.net
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <img src={phoneIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  Support (8 AM – 8 PM)
                </span>
              </div>
              <div className="flex items-center gap-2.5">
                <img src={buildingIcon} alt="" className="w-4 h-4" />
                <span className="text-[16px] tracking-[-0.04em] font-medium text-[#20262b] font-albert-sans">
                  Sunday – Thursday (8 AM – 6 PM)
                </span>
              </div>
            </div>
          </EmergencyCTASection>
          <Footer />
        </>
      }
    />
  );
}

export default Contact;
